import React from 'react'
import './Iconbox.css'
import { Link } from 'react-router-dom';
import Secimg from '../../assets/image-2.jpeg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(fas)

const Iconbox = () => {
  return (
    <div class="iconbox-section ws-section">
        <div class="container">
            <div class="row">
                <div class="col-lg-3 mb-4 column-1">
                    <div class="icon-box p-4">
                    <div class="icon-box-top">
                    <span>01</span>
                    </div>
                    <div class="icon-box-icon pb-4">
                        <FontAwesomeIcon icon="fa-solid fa-clock" /> 
                    </div>
                    <div class="icon-box-content">
                    <h4 class="pb-2">Comprehensive VLSI Curriculum</h4>
                    <p>Crafting long-term goals and competitive strategies.</p>
                    </div>
                    </div>
                </div>
                <div class="col-lg-6 align-self-center mb-4 text-center column-2">
                    <h2 class="ws-section_heading ">Create a Strong Starting Point for Your VLSI Career</h2>
                    <div className='d-flex'>
                        <a href="/product-category/vlsi-courses-for-freshers/">
                        <button class="btn-primary btn-icon mb-3">Discover more<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                        </a>
                        <a href="/contact-us/">
                        <button class="btn-secondary btn-icon btn-outline mb-3">Let's talk<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                        </a>
                    </div>
                </div>
                <div class="col-lg-3 mb-4 column-3">
                <div class="icon-box p-4">
                    <div class="icon-box-top">
                    <span>02</span>
                    </div>
                    <div class="icon-box-icon pb-4">
                        <FontAwesomeIcon icon="fa-solid fa-clock" /> 
                    </div>
                    <div class="icon-box-content">
                    <h4 class="pb-2">Practical <br/> Work</h4>
                    <p>We offering specialized training in these fields.</p>
                    </div>
                    </div>
                </div>
            
                <div class="col-lg-3 mb-4 column-4">
                    <div class="icon-box p-4">
                    <div class="icon-box-top">
                    <span>03</span>
                    </div>
                    <div class="icon-box-icon pb-4">
                        <FontAwesomeIcon icon="fa-solid fa-clock" /> 
                    </div>
                    <div class="icon-box-content">
                    <h4 class="pb-2">Research and Development</h4>
                    <p>We structured approach to exploring new knowledge</p>
                    </div>
                    </div>
                </div>
                <div class="col-lg-6 mb-4 align-self-center column-5">
                    <img src={Secimg} alt=''/>
                </div>
                <div class="col-lg-3 mb-4 column-6">
                <div class="icon-box p-4">
                    <div class="icon-box-top">
                    <span>04</span>
                    </div>
                    <div class="icon-box-icon pb-4">
                        <FontAwesomeIcon icon="fa-solid fa-clock" /> 
                    </div>
                    <div class="icon-box-content">
                    <h4 class="pb-2">Industry Collaboration</h4>
                    <p>We collaborate with companies to conduct placement.</p>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Iconbox